import React, { PropTypes, Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { getValueFromQueryString, extractIdentityObjectFromIdentifier } from '../../util/sharedFunctions';


class EasyLoginForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { handleSubmit, pristine, submitting } = this.props;

    return (
      <form>
        <div className="heading-text">
          <h4>Confirm Postcode</h4>
        </div>
        <div className="page-login-input">
          <i className="login-icon fa fa-user" />
          <Field name="postcode" component="input" type="text" placeholder="Postcode" />
        </div>

        <a href="#" disabled={pristine || submitting} className="button button-green button-icon button-full half-top full-bottom" onClick={handleSubmit}>
          <i className="fa fa-angle-right" /> Login
        </a>

        <div className="decoration" />
      </form>
    );
  }
}

let EasyLogin = reduxForm({
  form: 'easyLoginForm'
})(EasyLoginForm);

let mapStateToProps = function (state, ownProps) {
  let code = getValueFromQueryString(ownProps.location.search, 'code');//cuz the .query strips the '+' characters we have to get the 'code' the hard way
  let identity = getValueFromQueryString(ownProps.location.search, 'identity');
  let identityObject = extractIdentityObjectFromIdentifier(identity);

  return {
    initialValues: {
      userName: identityObject.userName,
      userId: identityObject.userId,
      code: code,
      jobId: identityObject.jobId,
      merchantId: identityObject.merchantId
    }
  };
};

EasyLogin = connect(mapStateToProps)(EasyLogin);

export default EasyLogin;



// WEBPACK FOOTER //
// ./app/auth/components/easyLogin.js